import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { useBranding } from "../../hooks";

export const sidebarWidth = 300;
export const sidebarSpeed = "0.4s";
export const rootContainerId = "intake-form-root-container";

export const ScrollWrapper = ({
  children,
  newUI,
  isPreview,
}: {
  children: React.ReactNode;
  newUI?: boolean;
  isPreview?: boolean;
}) => (
  <div
    id={rootContainerId}
    className={clsx(
      "w-full h-full overflow-clip top-0 left-0 @container",
      isPreview && "rounded",
      newUI ? "relative" : "absolute",
    )}
  >
    {children}
  </div>
);

export const PageWrapper = ({
  children,
  sidebar,
}: {
  children: React.ReactNode;
  sidebar: boolean;
}) => (
  <div
    className={clsx(
      "w-full h-full overflow-x-hidden overflow-y-auto transition-[padding-left] duration-[0.4s] ease-in-out scroll-smooth scroll-pt-[15rem]",
      sidebar ? "@tablet:pl-[30rem]" : "@tablet:pl-0",
    )}
    data-testid="page-wrapper"
  >
    {children}
  </div>
);

const backgroundColorClassNames: Record<string, string> = {
  default: "bg-neutral-50",
  brandColor: "bg-[var(--brand-color)]",
  white: "bg-white",
  transparent: "bg-transparent",
};

export const Page = ({
  children,
  className,
  isPreview,
}: {
  children: React.ReactNode;
  className?: string;
  isPreview?: boolean;
}) => {
  const branding = useBranding();
  const backgroundColorClass =
    backgroundColorClassNames[branding?.backgroundColor || "default"] ||
    backgroundColorClassNames.default;

  return (
    <div className={clsx(backgroundColorClass, "min-h-full print:bg-white")}>
      <main
        className={clsx(
          "rounded-small mx-auto pb-[10rem] mobile:max-w-[90%] mobile:w-[80rem] mobile:pt-[1.6rem] w-full pt-[0rem] print:pb-0",
          isPreview && "w-full max-w-full pt-[0rem] pb-[5rem]",
          className,
        )}
      >
        {children}
      </main>
    </div>
  );
};

export const Section = ({
  children,
  className,
  dataTestId,
}: {
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
}) => (
  <section
    className={twMerge(
      clsx("px-[3.2rem] pt-[3.2rem] pb-[5.6rem] rounded bg-white", className),
    )}
    data-testid={dataTestId || "section"}
  >
    {children}
  </section>
);
